<div class="col-12 " *ngIf="blockedDayList && garageVisitPlaceList" #Heder>
  <h2 *ngIf="currentGarage">{{currentGarage.Name}}</h2>
  <h2 *ngIf="currentGarage">{{currentGarage.Street}}</h2>
</div>

<!--<div class="container desktop-only">
  <div class="row">
    <div class="col-4"></div>
    <div class="col-4">
      <button style="margin-bottom: 20px;" [disabled]="false" class="btn btn-primary form-control" (click)="onChangeGarageClick()">
        Zmiana serwisu
      </button>
    </div>
    <div class="col-4"></div>
  </div>
</div>-->

<!--<div class="container  mobile-only">
  <div class="row">
    <div class="col text-center">
      <button style="margin-bottom: 20px;" [disabled]="false" class="btn btn-primary form-control" (click)="onChangeGarageClick()">
        Zmiana serwisu
      </button>
    </div>
  </div>
</div>-->

<div [hidden]="currentStep != 0  || IsFormProcessing() || (carCheck && carCheck.IsCustomerCar)">

  <div class="desktop-only d-flex justify-content-center flex-nowrap" *ngIf="blockedDayList && garageVisitPlaceList" #Callendar>
    <div class="text-white mx-2 p-2">
      <p-calendar [(ngModel)]="currentDate" [numberOfMonths]="2" [inline]=" true" [locale]="localizationCalendarConfig" dateFormat="dd.mm.yyyy" (onSelect)="onSelect($event)" (onMonthChange)="onMonthChange($event)">
        <ng-template pTemplate="date" let-date>
          <span [ngStyle]="{backgroundColor: IsDayBlocked(date) ? '#AAA' : 'inherit'}" style="border-radius: 20%; padding: 2px;">{{date.day}}</span>
        </ng-template>
      </p-calendar>
    </div>
  </div>

  <div class="d-flex justify-content-center flex-nowrap mobile-only" *ngIf="blockedDayList && garageVisitPlaceList && garageVisits">
    <div class="text-white mx-2 p-2">
      <p-calendar [(ngModel)]="currentDate" [numberOfMonths]="1" [inline]=" true" [locale]="localizationCalendarConfig" dateFormat="dd.mm.yyyy" (onSelect)="onSelect($event)" (onMonthChange)="onMonthChange($event)">
        <ng-template pTemplate="date" let-date>
          <span [ngStyle]="{backgroundColor: IsDayBlocked(date) ? '#AAA' : 'inherit'}" style="border-radius: 20%; padding: 2px;">{{date.day}}</span>
        </ng-template>
      </p-calendar>
    </div>
  </div>

  <div class="d-flex justify-content-center flex-nowrap" *ngIf="garageVisitPlaceList && garageVisits && carTypes && IsGarageOpen()" #CarType>
    <div class="text-white mx-2 p-2">
      <table *ngIf="IsGarageOpen()" style="border-spacing: 10px; font-size:14px;" class="car-type-table">
        <tr>
          <th [attr.colspan]="carTypes.length">
            Typ samochodu
          </th>
        </tr>
        <tr>
          <td *ngFor="let carType of carTypes;" (click)="onChangeCarTypeClick(carType)" [ngClass]="{'selected': carType.CarTypeId === newGarageVisit.CarTypeId}">
            {{carType.Name}}
          </td>
        </tr>
        <tr *ngIf="displayMissingCarType">
          <td [attr.colspan]="carTypes.length" class="warning">
            Proszę wybrać typ samochodu.
          </td>
        </tr>
        <tr *ngIf="displayInvalidCarType">
          <td [attr.colspan]="carTypes.length" class="warning">
            Nieodpowiedni typ stanowiska dla wybranego samochodu.
          </td>
        </tr>
      </table>
    </div>
  </div>



  <div class="d-flex justify-content-center flex-nowrap " *ngIf="garageVisitPlaceList && garageVisits && carTypes && visitTyreSources">

    <div class="text-white mx-2 p-2">

      <table *ngIf="IsGarageOpen()" style="border-spacing: 10px; font-size:14px;" class="garage-visit-place-table">
        <tr>
          <th></th>

          <th *ngIf="GarageVisitPlaceOfflineCount() == 1" style="background-color: #0091D5;">Offline</th>
          <th *ngIf="GarageVisitPlaceOfflineCount() > 1" [attr.colspan]="GarageVisitPlaceOfflineCount()" style="background-color: #0091D5;">Offline</th>

          <th *ngIf="GarageVisitPlaceOnlineCount() == 1" style="background-color: #6AB187; color: white;">Stanowiska</th>
          <th *ngIf="GarageVisitPlaceOnlineCount() > 1" [attr.colspan]="GarageVisitPlaceOnlineCount()" style="background-color: #6AB187;">Stanowiska</th>
        </tr>
        <tr>
          <td style="background-color: #0091D5;">Godziny</td>
          <td *ngFor="let garageVisitPlace of GarageVisitPlaceOffline(); let i = index;" style="background-color: #a8e3ff; color: black;">
            <i class="fa fa-car" aria-hidden="true" *ngIf="IsCarPlace(garageVisitPlace)"></i>

            <i class="fa fa-bus" aria-hidden="true" *ngIf="IsTrackPlace(garageVisitPlace)"></i>

            {{garageVisitPlace.Name}}
          </td>
          <td *ngFor="let garageVisitPlace of GarageVisitPlaceOnline(); let i = index;" style="background-color: #bdffd8; color: black;">
            <i class="fa fa-car" aria-hidden="true" *ngIf="IsCarPlace(garageVisitPlace)"></i>

            <i class="fa fa-bus" aria-hidden="true" *ngIf="IsTrackPlace(garageVisitPlace)"></i>

            {{garageVisitPlace.Name}}
          </td>
        </tr>

        <tr *ngFor="let timeSlot of timeSlots; let i = index;" class="time-slot">
          <td class="time-slot-label">
            {{timeSlot.Label}}
          </td>


          <ng-container *ngFor="let garageVisitPlace of GarageVisitPlaceOnline(); let i = index;">
            <td *ngIf="IsTimeSlotDisplay(timeSlot,garageVisitPlace)" class="time-slot" [ngStyle]="SetTimeSlotStyles(timeSlot,garageVisitPlace)" (click)="AddNewVisit(timeSlot,garageVisitPlace)" [attr.rowspan]="SetRowSpan(timeSlot,garageVisitPlace)">
              <div *ngIf="!IsTimeSlotFree(timeSlot,garageVisitPlace)">
                <span *ngIf="GetGarageVisit(timeSlot,garageVisitPlace).RegistrationNumber && GetGarageVisit(timeSlot,garageVisitPlace).RegistrationNumber.lenght > 0; else Occupied">{{GetGarageVisit(timeSlot,garageVisitPlace).RegistrationNumber}}</span>
                <ng-template #Occupied><span>Zajęte</span></ng-template>
              </div>
              <div *ngIf="IsReservationValid(timeSlot,garageVisitPlace)"><i class="fa fa-plus-square-o" aria-hidden="true"></i></div>
            </td>
          </ng-container>
        </tr>
      </table>

      <div *ngIf="!IsGarageOpen()" class="alert alert-dark mt-3 mb-3"><h3>Brak dostępnych terminów w tym dniu w celu rezerwacji wizyty skontaktuj się telefonicznie z serwisem: {{currentGarage.Name}}, tel. {{currentGarage.Telephone}}.</h3></div>
    </div>
  </div>





</div>

<div [hidden]="currentStep != 1 || IsFormProcessing() || (carCheck && carCheck.IsCustomerCar)">

  <div class="col-12 ">
    <h2 *ngIf="newGarageVisit">{{newGarageVisit.VisitDate| date:'yyyy.MM.dd'}} {{newGarageVisit.TimeSlotLabel}}</h2>
  </div>

  <div class="d-flex justify-content-center flex-nowrap" #MainForm>
    <div class="text-white mx-2 p-2">

      <form [formGroup]="formMain">

        <div class="row">
          <div class="col-6">
            <app-control-text-input [placeholder]="'Nr rejestracyjny'"
                                    [label]="'Nr rejestracyjny (*)'"
                                    [bindValue]="'RegistrationNumber'"
                                    [model]="newGarageVisit"
                                    [isDisabled]="false"
                                    [controlName]="inputRegistrationNumber"
                                    [maxLength]="7" [minLength]="4">
            </app-control-text-input>
          </div>
        </div>


        <div class="row">
          <div class="col-6">
            <app-control-text-input [placeholder]="'Imię'" [label]="'Imię (*)'" [bindValue]="'FirstName'" [model]="newGarageVisit" [controlName]="inputFirstName" [maxLength]="30" [minLength]="3">
            </app-control-text-input>
          </div>
          <div class="col-6">
            <app-control-text-input [placeholder]="'Nazwisko'" [label]="'Nazwisko (*)'" [bindValue]="'LastName'" [model]="newGarageVisit" [controlName]="inputLastName" [maxLength]="50" [minLength]="3">
            </app-control-text-input>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <app-control-telephone-input [placeholder]="'Nr tel komórkowego'" [label]="'Telefon (*)'" [bindValue]="'Telephone'" [model]="newGarageVisit" [controlName]="inputPhoneNr" [isLandlinePhone]="false" (ngValidationError)="onValidationTelephone($event)">
            </app-control-telephone-input>
          </div>

          <div class="col-6">
            <app-control-email-input [placeholder]="'Mail'" [bindValue]="'Mail'" (ngValidationError)="onValidationEmail($event)" [model]="newGarageVisit" [controlName]="inputMail" [label]="'Mail (*)'">
            </app-control-email-input>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <app-control-text-input [placeholder]="'Marka'" [label]="'Marka (*)'" [bindValue]="'CarWmakesName'" [model]="newGarageVisit" [controlName]="inputCarWmakesName">
            </app-control-text-input>
          </div>

          <div class="col-6">
            <app-control-text-input [placeholder]="'Model'" [label]="'Model (*)'" [bindValue]="'CarWmodelName: '" [model]="newGarageVisit" [controlName]="inputCarWmodelName">
            </app-control-text-input>
          </div>
        </div>

        <div class="d-flex justify-content-center flex-nowrap" *ngIf="visitTyreSources">
          <div class="text-white mx-2 p-2">
            <table style="border-spacing: 10px; font-size:14px;" class="car-type-table">
              <tr>
                <th [attr.colspan]="visitTyreSources.length">
                  Skąd pochodzą opony  (*)
                </th>
              </tr>
              <tr>
                <td *ngFor="let visitTyreSource of visitTyreSources;" (click)="onChangeVisitTyreSourceClick(visitTyreSource)" [ngClass]="{'selected': visitTyreSource.VisitTyreSourceId === newGarageVisit.VisitTyreSourceId}">
                  {{visitTyreSource.Name}}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <app-control-checkbox-input [label]="'Całe koła'"
                                        [bindValue]="'TyresWithRims'"
                                        [model]="newGarageVisit">
            </app-control-checkbox-input>
          </div>

          <div class="col-4" *ngIf="diameters && newGarageVisit.CarTypeId == 1">
            <app-control-select [items]="diameters"
                                [placeholder]="'Rozmiar opon'"
                                [label]="'Rozmiar opon (*)'"
                                [bindValue]="'Value'"
                                [bindLabel]="'Value'"
                                [isBadges]="false"
                                [modelBindValue]="'TyreDiameter'"
                                [model]="newGarageVisit"
                                [isRequired]="true"
                                [isDialog]="true">
            </app-control-select>

          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <app-control-textarea rows="3" [placeholder]="'Uwagi'" [label]="'Uwagi'" [bindValue]="'Note'" [model]="newGarageVisit" [isRequired]="false"></app-control-textarea>
          </div>
        </div>


        <div class="row">
          <div class="col-12">
            <app-control-checkbox-input [label]="'Wyrażam zgodę na przetwarzanie moich danych osobowych dla potrzeb niezbędnych do realizacji przez Point-S usługi wymiany opon (zgodnie z Ustawą z dnia 29.08.1997 roku o Ochronie Danych Osobowych; tekst jednolity: Dz. U. z 2002r. Nr 101, poz. 926 ze zm.). (*)'"
                                        [bindValue]="'IsAldConsent'"
                                        [model]="newGarageVisit">
            </app-control-checkbox-input>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <app-control-checkbox-input [label]="'Wyrażam zgodę na przetwarzanie przez Point-S  moich danych osobowych w postaci imienia, nazwiska i adresu do korespondencji w celu przesyłania mi informacji marketingowych dotyczących produktów i usług oferowanych przez Point-S za pomocą poczty elektronicznej.'"
                                        [bindValue]="'IsAldConsentToAdvertising'"
                                        [model]="newGarageVisit">
            </app-control-checkbox-input>
          </div>
        </div>
      </form>


      <div class="row">
        <div class="col-6">
          <button style="margin-bottom: 20px;" [disabled]="false" class="btn btn-primary form-control" (click)="onBack()">
            Zmień termin
          </button>
        </div>
        <div class="col-6">
          <button style="margin-bottom: 20px;" [disabled]="!IsFormValid()" class="btn btn-primary form-control" (click)="onCarCheck()">
            Rezerwuj termin
          </button>
        </div>
      </div>

      <div class="row statute">
        <div class="col-12">
          * - wymagane
        </div>
      </div>

      <div class="row statute">
        <div class="col-12">
          <strong>Regulamin</strong>
          <ol>
            <li>Usługa rezerwacji stanowiska on-line jest prowadzona i zarządzana przez firmę Point S Polska Sp. z.o.o.</li>
            <li>Zadaniem usługi jest umożliwienie rezerwacji za pośrednictwem sieci Internet wolnego stanowiska w serwisie opon w/w firmy, o ustalonej godzinie w ustalonym dniu na czas 30 minut.</li>
            <li>Rezerwacji jest bezpłatna i może jej dokonać każdy, kto posiada dostęp do Internetu.</li>
            <li>Warunkiem poprawnej rezerwacji jest wprowadzenie imienia i nazwiska rezerwującego, telefonu kontaktowego oraz numeru rejestracyjnego pojazdu.</li>
            <li>Firma Point S. zastrzega sobie możliwość telefonicznego potwierdzenia rezerwacji stanowiska, choć nie jest ono konieczne.</li>
            <li>Spóźnienie dłuższe niż 5 minut powoduje, że termin rezerwacji przepada. Konieczne jest ustalenie nowego, już w standardowym trybie.</li>
            <li>Numer rejestracyjny pojazdu klienta, który nie pojawił się, bądź spóźnił na umówioną godzinę może być przy kolejnych próbach rezerwacji odrzucony przez operatora systemu.</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="!garageVisitPlaceList || !garageVisits || !diameters || IsFormProcessing()">
  <div class="container z-index-master">
    <div class="row align-items-center">
      <div class="col-md-12">
        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="carCheck && carCheck.IsCustomerCar">

  <div class="row">
    <div class="col-12 ">
      <div class="menu-box-visit m-2 p-2">
        <div class="menu-box-visit-text p-1">
          Samochód o numerze rejestracyjnym <b>{{newGarageVisit.RegistrationNumber}}</b> jest zarejestrowany w systemie  Point-S. Możesz przejść do serwisu wymiany opon przeznaczonego dla klientów Point-S aby mieć dostęp do listy depozytów opon, relokacji i listy zamówień opon.
        </div>
        <div class="menu-box-visit-text p-1" *ngIf="carCheck.GaragesWithDeposites && carCheck.GaragesWithDeposites.length > 0">
          Samochód posiada depozyty opon w następujących serwisach:
          <div class="row" *ngFor="let garage of carCheck.GaragesWithDeposites;" (click)="onChangeGarateClick(garage)">
            <div class="col-md-12" style="cursor:pointer;">{{garage.Name}}</div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm">
            <div>

            </div>
            <button style="margin-bottom: 20px;" [disabled]="false" class="btn btn-primary form-control text-nowrap" (click)="onGoToALD()">
              Przejdz do serwisu klientów Point-S
            </button>
          </div>
          <div class="col-sm">
            <button style="margin-bottom: 20px;" [disabled]="!IsFormValid()" class="btn btn-primary form-control text-nowrap" (click)="onSaveNewVisit()">
              Kontynuuj jako klient anonimowy
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


</ng-container>
